import * as UserInfoType from "../actionTypes/userInfo";

export const setPhone = phoneNumber => ({
  type: UserInfoType.SET_PHONE,
  payload: phoneNumber
});
